import { render, staticRenderFns } from "./box-list.vue?vue&type=template&id=6087d124&scoped=true"
import script from "./box-list.vue?vue&type=script&lang=js"
export * from "./box-list.vue?vue&type=script&lang=js"
import style0 from "./box-list.vue?vue&type=style&index=0&id=6087d124&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087d124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6087d124')) {
      api.createRecord('6087d124', component.options)
    } else {
      api.reload('6087d124', component.options)
    }
    module.hot.accept("./box-list.vue?vue&type=template&id=6087d124&scoped=true", function () {
      api.rerender('6087d124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/store-manage/box-list.vue"
export default component.exports